import { render, staticRenderFns } from "./HotelTab.vue?vue&type=template&id=5291a026&scoped=true&"
import script from "./HotelTab.vue?vue&type=script&lang=js&"
export * from "./HotelTab.vue?vue&type=script&lang=js&"
import style0 from "./HotelTab.vue?vue&type=style&index=0&id=5291a026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5291a026",
  null
  
)

export default component.exports